import { useEffect, useState } from "react";
import { RevisionDetails } from "../../../store/Models/Surveys/SurveyDataModel";
import IngredientsTableColumnManager from "../../../utilities/IngredientsTableColumn";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";

interface RevisionRequestProps {
    revisionRequestInstructions?: string;
    revisionRequestInstructionsList?: RevisionDetails[];
    revisionRequestTitle?: string;
    afterRenderCallback?: () => void;
    localizer: IStringLocalizer;
    extensibleColumnNames: string[];
}

const RevisionRequest: React.FC<RevisionRequestProps> = ({ revisionRequestInstructions, revisionRequestInstructionsList, revisionRequestTitle, afterRenderCallback, localizer, extensibleColumnNames }) => {
    const ingredientsTableColumnManager = new IngredientsTableColumnManager();
    const ingredientsColumnFriendlyNames = ingredientsTableColumnManager.getIngredientsColumnFriendlyNames(localizer, extensibleColumnNames);

    useEffect(() => {
        if (afterRenderCallback !== undefined) {
            afterRenderCallback();
        }
    });

    return (
        revisionRequestInstructions && revisionRequestInstructions != undefined && revisionRequestInstructions.length > 0
            ? <div className="survey-revision-request-wrapper alert alert-warning m-b-10" key="revision-instruction">
                <p><strong>{revisionRequestTitle}</strong></p>
                <p>{revisionRequestInstructions}</p>
              </div>
            :
            revisionRequestInstructionsList && revisionRequestInstructionsList.length > 0
                ? <div className="survey-revision-request-wrapper alert alert-warning m-b-10" key="revision-instructions-list">
                    <p><strong>{revisionRequestTitle}</strong></p>
                    <ul>
                        {revisionRequestInstructionsList.map((rev, index) =>
                            <li key={`revision-${index}`}>{rev.columnId != null && rev.columnId != undefined ? `${localizer.localizeString("Column")} ${ingredientsColumnFriendlyNames[rev.columnId]}: ${rev.revisionInstructions}` : rev.revisionInstructions}</li>
                        )}
                    </ul>
                  </div>
                : null
    );
};

export default RevisionRequest;
